define.alias("shared/components/shared/upgrade/plan-highlight", "preview-grid/components/shared/upgrade/plan-highlight");